import React, { useState, useMemo, useEffect } from "react"
import { Grid, Container, useMediaQuery } from "@material-ui/core"
import {
    InputHLPure,
    ButtonHLPure,
    DialogSystemGLPure,
    SubtitlePageHLPure,
    TextAreaHLPure,
    HeaderHLPure,
    DropDownBtnHLPure,
    ComboBoxTemplatePure,
    CheckBoxHLPure,
    InputFileHLPure,
    DialogPdf,
    TooltipHLPure
} from "../../../pures"
import { useTranslation } from "react-i18next"
import PdfReader from '../../../pures/adobePfdReader/PdfReader'

import "./documents-to-require-add-new-document.view.css"
import { b64toBlob } from "../../../../validators"

const DocumentsToRequireAddDocumentView = ({
    selectedValueFilter,
    hideShowDetails,
    validators,
    createClientDocument,
    token,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    toggleErrorRequesting,
    setShowLoadingRequesting,
    setShowCompletedRequesting,
    setShowErrorRequesting,
    typeDocuments,
    preferenceValue,
    handleFile,
    handleDeleteFile,
    selectedFile,
    selectedFileName,
    errorFile,
    selectedFileBase64,
    newOptions
}) => {
    const { t } = useTranslation();
    let ENV = process.env
    const [documentName, setDocumentName] = useState("")
    const [documentDescription, setDocumentDescription] = useState("")
    const [documentTypeId, setDocumentTypeId] = useState('Sin clasificación')
    const [errorInDocumentName, setErrorInDocumentName] = useState(undefined)
    const [errorInDescription, setErrorInDescription] = useState(undefined)
    const [typeDocument, setTypeDocument] = useState('')
    const [errorTypeDocument, setErrorTypeDocument] = useState(false)
    const [ocrCheck, setOcrCheck] = useState(false)
    const [blobUrl, setBlobUrl] = useState("");

    const pdf = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`}  ></PdfReader>, [selectedFileBase64])

    let typePersonTitle = t("documentsToRequire.classifiedForPhysical")

    if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL) {
        typePersonTitle = t("documentsToRequire.classifiedForMoral")
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL) {
        typePersonTitle = t("documentsToRequire.classifiedForREPSEPhysical")
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL) {
        typePersonTitle = t("documentsToRequire.classifiedForREPSEMoral")
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE) {
        typePersonTitle = t("documentsToRequire.classifiedForContractREPSE")
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE) {
        typePersonTitle = t("documentsToRequire.classifiedForReporREPSE")
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER) {
        typePersonTitle = t("documentsToRequire.classifiedProcedureUser")
    }


    useEffect(() => {
        if (selectedFileBase64) {
            const blob = b64toBlob(selectedFileBase64, "application/pdf");
            setBlobUrl(blob);
        }
    }, [selectedFileBase64]);

    const handleChangeDropdown = (e) => {
        setDocumentTypeId(e.target.value)
    }

    const handleCreateClientDocument = () => {
        let personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID)
        if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_SIGNERS) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_SIGNERS_ID)
        } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES) {
            personTypeId = Number(ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES_ID)
        }

        let invalidDocumentName = validators.documentNameValidator(documentName)
        let invalidDescription = validators.documentDescriptionValidator(documentDescription)

        if (invalidDocumentName != "") {
            setErrorInDocumentName(true)
            return
        } else {
            setErrorInDocumentName(false);
        }

        if (invalidDescription != "") {
            setErrorInDescription(true)
            return
        } else {
            setErrorInDescription(false);
        }

        if (!typeDocument) {
            setErrorTypeDocument(true)
            return
        }

        if (invalidDocumentName == "" && invalidDescription == "") {
            let clientDocumentTypeRequestIdSend = (documentTypeId && documentTypeId !== 'Sin clasificación') ? Number(documentTypeId) : 0
            const body = {
                clientDocumentTypeRequestId: clientDocumentTypeRequestIdSend,
                documentPersonTypeId: personTypeId,
                nombre: documentName,
                description: documentDescription,
                defaultDocument: false,
                sendOCR: ocrCheck,
                typeDocumentName: (typeDocument && typeDocument.name) ? typeDocument.name : null,
                documentForm: (selectedFile) ? selectedFile : null,
            }
            createClientDocument(body, token)
        }
    }

    const handleChangeDocumentName = (e) => {
        setDocumentName(e.target.value);
    };

    const handleChangeDocumentDescription = (e) => {
        setDocumentDescription(e.target.value);
    };

    const handleChangeTypeDocument = (e) => {
        setErrorTypeDocument(false)
        setTypeDocument(e.target.value)
    }

    const onChangeCheckBoxOCR = (e) => {
        setOcrCheck(e.target.checked)
    }

    const handleBack = () => {
        handleDeleteFile()
        hideShowDetails()
    }

    const isMobile = useMediaQuery("(max-width:560px)")

    return (
        <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="documentsToRequireDetailsView-wrapper"
        >
            {showLoadingRequesting ?
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    toggleLoadingRequesting={() => { setShowLoadingRequesting(!showLoadingRequesting) }}
                />
                : null}
            {showCompletedRequesting ? (
                <DialogSystemGLPure
                    showCompletedRequesting={showCompletedRequesting}
                    toggleCompletedRequesting={() => { setShowCompletedRequesting(!showCompletedRequesting) }} />
            ) : null}
            {showErrorRequesting ? (
                <DialogSystemGLPure
                    showErrorRequesting={showErrorRequesting}
                    toggleErrorRequesting={() => { setShowErrorRequesting(showErrorRequesting) }} />) : null}
            <Grid
                item
                lg={12}
                md={12}
                xs={12}
                sm={12}
            // className="documentsToRequireDetailsView-header"
            >
                <HeaderHLPure
                    title={t("documentsToRequire.addDocumentTitle")}
                />

            </Grid>
            <Container maxWidth={"md"} disableGutters>
                <div className="documentToRequireDetailsHeader-subtitle-dv">
                    {typePersonTitle}
                </div>

                {/*Container primera seccion de items, fila*/}
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="documentsToRequireDetailsView-form"
                >
                    {/*Container first second items, col 1*/}
                    <Grid
                        // container
                        className="documentsToRequireDetailsView-inputs"
                        xs={12}
                    >
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            es={3}
                            className="documentsToRequireDetailsView-col1"
                        >
                            <Grid item className="documentsToRequireDetailsView-inputHLPure">
                                <InputHLPure
                                    labelInput={t("documentsToRequire.documentName")}
                                    valueInput={documentName}
                                    tooltipShow={true}
                                    inputActive
                                    required
                                    positionTooltip={isMobile ? "top" : "right"}
                                    titleTooltip={t("documentsToRequire.tooltipTitle")}
                                    descriptionTooltip={`${t("documentsToRequire.tooltipDocumentName")} ${t("documentsToRequire.validCharactersDescription")}`}
                                    informationIcon={true}
                                    handleChangeInput={(e) => handleChangeDocumentName(e)}
                                    errorInput={errorInDocumentName}
                                    errorInputText={t("documentsToRequire.hintErrorMesaggeInDocument")}
                                />
                            </Grid>
                            <Grid item className="documentsToRequire-dropdownMenu">
                                <DropDownBtnHLPure
                                    labelDropDown={t("documentsToRequire.detail.requestType")}
                                    optionsDropDown={newOptions}
                                    onDropDownChange={(e) => handleChangeDropdown(e)}
                                    valueItem={"value"}
                                    nameOption={"name"}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} className="documentsToRequire-ocr">
                                <CheckBoxHLPure
                                    checkedState={ocrCheck}
                                    onChangeHandler={(e) => onChangeCheckBoxOCR(e)}
                                />
                                <div className="documentsToRequire-check-ocr">
                                    <span className="documentsToRequire-ocr-label">
                                        {t("documentsToRequire.proccess.ocr")}
                                    </span>
                                    <TooltipHLPure
                                        positionTooltip={isMobile ? "top" : "right"}
                                        titleTooltip={t("documentsToRequire.title.ocr")}
                                        descriptionTooltip={t("documentsToRequire.description.ocr")}
                                        informationIcon={true}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} className="documentsToRequire-type-document">
                                <ComboBoxTemplatePure
                                    title={t("documentsToRequire.type.document")}
                                    placeholder={t("documentsToRequire.type.document.placeholder")}
                                    allowCustom
                                    data={typeDocuments}
                                    textField="name"
                                    dataItemKey="id"
                                    value={typeDocument}
                                    onChange={(e) => handleChangeTypeDocument(e)}
                                    required
                                    validityStyles={false}
                                    errorCombobox={errorTypeDocument}
                                    tooltipShow={true}
                                    errorMessage={t("documentsToRequire.type.document.error")}
                                    positionTooltip={isMobile ? "top" : "right"}
                                    titleTooltip={t("documentsToRequire.type.document")}
                                    descriptionTooltip={t("documentsToRequire.type.document.description")}
                                    informationIcon={true}
                                />
                            </Grid>
                        </Grid>
                        {/*Container second section items, col 2*/}
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="documentsToRequireDetailsView-col2"
                        >
                            <Grid item className="documentsToRequireDetailsView-inputHLPure">
                                <TextAreaHLPure
                                    labelTextArea={t("documentsToRequire.documentDescription")}
                                    valueTextData={documentDescription}
                                    handleChangeTextArea={(e) => handleChangeDocumentDescription(e)}
                                    errorInput={errorInDescription}
                                    errorTextArea={t("documentsToRequire.hintErrorMesaggeInDescription")}
                                    tooltipShow
                                    informationIcon
                                    positionTooltip={isMobile ? "top" : "right"}
                                    titleTooltip={t("documentsToRequire.documentDescription")}
                                    descriptionTooltip={`${t("documentsToRequire.tooltipDocumentDescription")} ${t("documentsToRequire.validCharactersDescription")}`}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <p className="documentsToRequire-required-label"><span>*</span> {t("documentsToRequire.requiredFields")}</p>
                        </Grid>
                        {
                            preferenceValue && selectedValueFilter && selectedValueFilter === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER ? (
                                <Grid container xs={12} className="documentsToRequire-documents">
                                    <InputFileHLPure
                                        messageBtn={t("documentsToRequire.btn.file")}
                                        flex={true}
                                        acceptFile={"application/pdf"}
                                        selectedFile={selectedFile}
                                        selectedFileName={selectedFileName}
                                        errorFile={errorFile}
                                        handleFile={(e) => handleFile(e)}
                                        handleDeleteFile={(e) => handleDeleteFile(e)}
                                    />
                                    <div className='documentsToRequire-documentPDF'>
                                        {(selectedFile) ? pdf : null}
                                    </div>
                                    <div className="documentsToRequire-pdf-btn">
                                        <DialogPdf blobUrl={blobUrl} />
                                    </div>
                                </Grid>
                            ) : null
                        }
                    </Grid>
                </Grid>

                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="documentsToRequireDetailsView-btnGroup"
                >
                    <div className="documentsToRequireDetailsView-spaceBtns">
                        <ButtonHLPure
                            secondary
                            nameBtn={t("documentsToRequire.returnButton")}
                            onClickBtn={() => handleBack()}
                        />
                    </div>
                    <div className="documentsToRequireDetailsView-spaceBtns">
                        <ButtonHLPure
                            primary
                            nameBtn={t("documentsToRequire.saveNewDocument")}
                            onClickBtn={handleCreateClientDocument}
                        />
                    </div>
                </Grid>
            </Container >
        </Grid >
    );
};

export default DocumentsToRequireAddDocumentView;
